import { isEmptyObject } from '../../core/util/object';
import { apiGetJson } from './index';
import { getCityLabelFromGeosuggestValue } from '../../components/Search/components/Filters/Fields/LocationInput/util';
import { safeGet } from '../util/object';

const getGeoCodeUrl = address => `/proxy/geocode?address=${encodeURIComponent(address)}`;

const formatLatitudeLongitude = latitudeLongitude =>
  `${latitudeLongitude.lat},${latitudeLongitude.lng}`;

const getReverseGeoCodeUrl = latitudeLongitude =>
  `/proxy/geocode?latlng=${formatLatitudeLongitude(latitudeLongitude)}`;

const parseLocationFromGeoCodeResult = data => {
  if (!isEmptyObject(data) && data.status === 'OK') {
    if (data.results && data.results.length > 0) {
      const latitudeLongitude = data.results[0].geometry.location;
      return {
        latitude: latitudeLongitude.lat,
        longitude: latitudeLongitude.lng,
        label: safeGet(data, '')('results.0.formatted_address').replace(', USA', ''),
      };
    }
  }

  return null;
};

const parseLocationFromReverseGeoCodeResult = result => {
  let city = null;
  let state = null;
  result.address_components.forEach(component => {
    if (component.types.indexOf('locality') !== -1) {
      city = component.long_name;
    }

    if (component.types.indexOf('administrative_area_level_1') !== -1) {
      state = component.short_name;
    }
  });

  const location = {
    latitude: result.geometry.location.lat,
    longitude: result.geometry.location.lng,
    cityLabel: getCityLabelFromGeosuggestValue(result),
  };

  if (city && state) {
    location.label = `${city}, ${state}`;
  }

  return location;
};

const geoCode = (locationString, onSuccess, onError) => {
  apiGetJson(getGeoCodeUrl(locationString))
    .then(result => {
      const location = parseLocationFromGeoCodeResult(result);
      if (location) {
        onSuccess(location);
      } else {
        onError(result);
      }
    })
    .catch(e => onError(e));
};

export {
  geoCode,
  getGeoCodeUrl,
  getReverseGeoCodeUrl,
  parseLocationFromGeoCodeResult,
  parseLocationFromReverseGeoCodeResult,
};
